var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"link-idx":2}}),_c('div',{staticClass:"mt80 g-min-height"},[_c('img',{staticClass:"img-top",attrs:{"src":require("@/assets/images/img_top2.png"),"alt":""}}),_c('div',{staticClass:"pt20 w1220"},[_c('TeamList')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }